@if (!isLoading()) {
  <div class="flex items-center justify-center gap-10 size-full">
    @if (isAdPopupOpen()) {
      <div
        class="overflow-hidden rounded-xl max-w-[40dvh] min-w-[40dvh]"
        [ngClass]="adClass()"
        [style.top.px]="adTop()"
        [style.left.px]="adLeft()"
      >
        <div class="relative">
          @if (adPopups().length > 1) {
            <div
              class="absolute z-10 top-2 right-4 text-white text-xs bg-black bg-opacity-50 px-2 py-1 rounded-xl"
            >
              <p>{{ adRealIndex() + 1 }} / {{ adPopups().length }}</p>
            </div>
          }
          <div
            swiper
            [options]="adSwiperOptions()"
            class="swiper"
            (realIndex)="adRealIndex.set($event)"
          >
            <div class="swiper-wrapper">
              @for (popup of adPopups(); track $index) {
                <div class="swiper-slide">
                  <a
                    [href]="popup?.linkUrl"
                    target="_blank"
                    [ngClass]="
                      popup?.linkUrl ? 'hover:opacity-80 transition-all' : ''
                    "
                  >
                    <img
                      [src]="popup?.imageUrl"
                      class="w-full min-h-[30dvh] max-h-[30dvh]"
                    />
                  </a>
                </div>
              }
            </div>
          </div>

          <div
            class="flex items-center px-5 py-4 text-sm text-white bg-zinc-700"
            [ngClass]="
              adPopupSetting()!.isShowTodayButton
                ? 'justify-between'
                : 'justify-end'
            "
          >
            @if (adPopupSetting()!.isShowTodayButton) {
              <button (click)="handleNotToday(adPopupSetting()!.type, $event)">
                오늘하루 그만보기
              </button>
            }
            <button (click)="close(adPopupSetting()!.type, $event)">
              닫기
            </button>
          </div>
        </div>
      </div>
    }

    @if (isNormalPopupOpen()) {
      <div
        class="overflow-hidden rounded-xl max-w-[40dvh] min-w-[40dvh]"
        [ngClass]="normalClass()"
        [style.top.px]="normalTop()"
        [style.left.px]="normalLeft()"
      >
        <div class="relative">
          @if (normalPopups().length > 1) {
            <div
              class="absolute z-10 top-2 right-4 text-white text-xs bg-black bg-opacity-50 px-2 py-1 rounded-xl"
            >
              <p>{{ normalRealIndex() + 1 }} / {{ normalPopups().length }}</p>
            </div>
          }

          <div
            swiper
            [options]="normalSwiperOptions()"
            class="swiper"
            (realIndex)="normalRealIndex.set($event)"
          >
            <div class="swiper-wrapper">
              @for (popup of normalPopups(); track $index) {
                <div class="swiper-slide">
                  <a
                    [href]="popup?.linkUrl"
                    target="_blank"
                    [ngClass]="
                      popup?.linkUrl ? 'hover:opacity-80 transition-all' : ''
                    "
                  >
                    <img
                      [src]="popup?.imageUrl"
                      class="w-full min-h-[30dvh] max-h-[30dvh]"
                    />
                  </a>
                </div>
              }
            </div>
          </div>
          @if (normalPopupSetting(); as normalPopupSetting) {
            <div
              class="flex items-center px-5 py-4 text-sm text-white bg-zinc-700"
              [ngClass]="
                normalPopupSetting?.isShowTodayButton
                  ? 'justify-between'
                  : 'justify-end'
              "
            >
              @if (normalPopupSetting?.isShowTodayButton) {
                <button
                  (click)="handleNotToday(normalPopupSetting!.type, $event)"
                >
                  오늘하루 그만보기
                </button>
              }
              <button (click)="close(normalPopupSetting!.type, $event)">
                닫기
              </button>
            </div>
          }
        </div>
      </div>
    }
  </div>
}
